<template>
  <v-data-table
    :value="selectedItems"
    :headers="headers"
    :items="items"
    :items-per-page="15"
    :search="search"
    :custom-filter="$options.localeIncludes"
    :loading="loading"
    :loading-text="$t('general.loading')"
    :hide-default-footer="!!$slots.footer"
    sort-by="displayName"
    :show-select="!!selected"
    @input="$emit('update:selected', $event.map(item => item.id))"
  >
    <template v-slot:[`item.logo`]="{ item }">
      <img
        v-if="item.logo"
        :src="`${logoSrcBase}/${item.id}/logo/${item.logo}`"
        class="company-logo-preview"
      >
    </template>
    <template v-slot:[`item.lastSessionDateCreation`]="{ item }">
      <ag-date-text
        v-if="item.lastSessionDateCreation"
        :value="item.lastSessionDateCreation"
        :format="$t('date.dateAndTime')"
      />
    </template>
    <template v-slot:[`item.activeTokenDemandNumber`]="{ item }">
      <v-btn
        v-if="item.activeTokenDemandNumber"
        :to="{ name: 'CompanyDemands', params: { companyId: item.id } }"
        height="30px"
        rounded
        small
        color="accent"
        dark
        v-text="item.activeTokenDemandNumber"
      />
    </template>
    <template v-slot:[`item.actions`]="{ item }">
      <v-btn
        :to="`/companies/${item.id}`"
        color="accent"
        small
        v-text="$t('general.update')"
      />
    </template>

    <template v-if="$slots.footer" v-slot:footer="{ props, on }">
      <v-row
        align="center"
        no-gutters
        class="px-2"
        style="border-top: thin solid rgba(0, 0, 0, 0.12)"
      >
        <v-col cols="auto">
          <slot name="footer" />
        </v-col>
        <v-col>
          <v-data-footer v-bind="props" style="border: none" v-on="on" />
        </v-col>
      </v-row>
    </template>
  </v-data-table>
</template>

<script>
import Config from 'src/config'
import AgDateText from 'src/components/common/AgDateText'

export default {
  name: 'CompanyList',
  components: {
    AgDateText,
  },
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    selected: {
      type: Array,
      default: null,
    },
    search: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    light: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    headers () {
      const baseHeaders = [
        {
          text: this.$t('company.fields.logo'),
          value: 'logo',
          align: 'center',
        },
        {
          text: this.$t('company.fields.companyLogin'),
          value: 'companyLogin',
          align: 'center',
        },
        {
          text: this.$t('company.fields.displayName'),
          value: 'displayName',
          align: 'center',
        },
      ]

      if (this.light) {
        return baseHeaders
      }

      return [
        ...baseHeaders,
        {
          text: this.$t('company.fields.tokenBalance'),
          value: 'tokenBalance',
          align: 'center',
        },
        {
          text: this.$t('company.fields.companyContact'),
          value: 'companyContact',
          align: 'center',
        },
        {
          text: this.$t('company.fields.masterContactList'),
          value: 'masterContactList',
          align: 'center',
        },
        {
          text: this.$t('company.fields.activeTokenDemandNumber'),
          value: 'activeTokenDemandNumber',
          align: 'center',
        },
        {
          text: this.$t('company.fields.lastSessionDateCreation'),
          value: 'lastSessionDateCreation',
          align: 'center',
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          filterable: false,
          align: 'center',
          width: '15%',
        },
      ]
    },
    items () {
      return this.value.map(company => ({
        id: company.id,
        logo: company.logo,
        companyLogin: company.companyLogin,
        displayName: company.displayName,
        tokenBalance: company.tokenBalance,
        companyContact: this.getUserFullName(company.companyContact),
        masterContactList: company.masterContactList.map(this.getUserFullName).join(', '),
        activeTokenDemandNumber: company.activeTokenDemandNumber,
        lastSessionDateCreation: company.lastSessionDateCreation,
      }))
    },
    logoSrcBase () {
      return `${Config.API_URL}company`
    },
    selectedItems () {
      return this.selected?.map(id => this.items.find(item => item.id === id))
    },
  },
  methods: {
    getUserFullName (user) {
      return user ? `${user?.firstName} ${user?.lastName}` : ''
    },
  },
}
</script>

<style lang="scss" scoped>
  .company-logo-preview {
    max-width: 50px;
    max-height: 40px;
    width: auto;
    height: auto;
    margin-top: 8px;
  }
</style>
